/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */


export const newKey = () => (typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
export const emptyLine = () => ({ _key: newKey(), description: '', quantity: 1, unit_price_eur: 0, vat_pct: 22 });

export const euro = (n) => `€ ${Number(n || 0).toFixed(2)}`;

// Anteprima fiscale lato client (specchio di backend/fiscal_it.py).
const BOLLO_THRESHOLD = 77.47;
const BOLLO_AMOUNT = 2.0;
export const computeFiscalPreview = (lines, { vatExempt, bolloToCustomer }) => {
  let subtotal = 0; let vat = 0; let exemptBase = 0;
  for (const l of lines) {
    const sub = (Number(l.quantity) || 0) * (Number(l.unit_price_eur) || 0);
    const pct = vatExempt ? 0 : (Number(l.vat_pct) || 0);
    subtotal += sub;
    vat += sub * pct / 100;
    if (pct === 0) exemptBase += sub;
  }
  const bolloDue = exemptBase > BOLLO_THRESHOLD;
  const bolloLine = bolloDue && bolloToCustomer ? BOLLO_AMOUNT : 0;
  return {
    subtotal: (subtotal + bolloLine).toFixed(2),
    vat: vat.toFixed(2),
    exemptBase: exemptBase.toFixed(2),
    bolloDue,
    total: (subtotal + vat + bolloLine).toFixed(2),
  };
};
